import { html, nothing } from 'lit';
import componentStyles from './monogram-card.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class MonogramCard extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * Main content area title
       */
      title: { type: String },
      /**
       * Main content area text below title
       */
      icon: { type: String },
      /**
       * Button url
       */
      bodyText: { type: String },
      /**
       * Main content area text below title
       */
      url: { type: String },
      /**
       * Link target
       */
      target: { type: String },
      /**
       * Card Header Level
       */
      levelHeader: { type: String },
      /**
       * Link new window
       */
      isNewWindow: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.bodyText = '';
    this.levelHeader = '3';
  }

  render() {
    if (this.url && this.target === '_blank' ) {
      this.isNewWindow = true;
    } 
    return html`
      <div class="monogram-card">
        <hf-icon name="${this.icon}" class="monogram-card__icon"></hf-icon>
        <div class="monogram-card__wrapper">
          <hf-link class="monogram-card__link" href="${this.url}" target="${this.target}" ignoreExternalUrl isNewWindow="${this.isNewWindow}">
            <hf-heading
              levelStyle="heading3"
              class="monogram-card__title"
              removeRole="${true}"
            >
              ${this.title}
              <hf-icon
                name="arrow-right"
                class="monogram-card__arrow"
              ></hf-icon>
            </hf-heading>
          </hf-link>
          ${this.bodyText.length
            ? html`
                <hf-paragraph
                  class="monogram-card__body-text"
                  styleclass="no-margin"
                  ><hf-wysiwyg markup="${this.bodyText}"></hf-wysiwyg
                ></hf-paragraph>
              `
            : nothing}
        </div>
      </div>
    `;
  }
}

customElements.define('hf-monogram-card', MonogramCard);
